module.exports = "/_next/static/images/628a4490a15d9cd35b33d0810194c6e0-challenge-the-system-lg@2x.jpg";